/* eslint-disable no-var */

declare global {
  var __EXPO_RSC_RELOAD_LISTENERS__: undefined | (() => void)[];
  var __EXPO_REFETCH_RSC__: undefined | (() => void);
  var __EXPO_REFETCH_ROUTE__: undefined | (() => void);
  var __EXPO_REFETCH_ROUTE_NO_CACHE__: undefined | (() => void);
  var __expo_platform_header: undefined | string;
}
